






























































































import Vue from 'vue';
import { IOrg, IWebhook } from '@/store/types';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';
import { SAVE_STATE } from '@/store/shared';
import OrgService from '@/api/org.service';

export default Vue.extend({
  name: 'WebhookManager',
  data() {
    return {
      webhookUrl: '',
      loading: false,
      tokenLoading: false,
      creatingNewEndpoint: false,
      showWebhookKey: false,
      webhookToken: '',
      SAVE_STATE,
    };
  },
  computed: {
    // orgWebhookIds(): string[] {
    //   return (this.$store.state.org && this.$store.state.org.webhooks) || [];
    // },
    webhooks(): IWebhook[] {
      return Object.keys(this.$store.state.webhooks)
        .sort()
        .map((id) => this.$store.state.webhooks[id])
        .filter((d) => !!d && !d.deleted);
    },
    org(): IOrg {
      return this.$store.state.org;
    },
  },
  methods: {
    async revealWebhookKey() {
      if (!this.webhookToken) {
        await this.getWebhookSecret();
      }
      this.showWebhookKey = true;
    },
    async getWebhookSecret() {
      this.tokenLoading = true;
      const res = await OrgService.getWebhookToken(this.$store.state.user.org);
      this.webhookToken = res.webhookSecret || '';
      this.tokenLoading = false;
    },
    async createWebhook() {
      try {
        this.loading = true;
        this.creatingNewEndpoint = false;
        // if no webhooks have been added yet, create an org secret
        if (this.org && this.org.secrets && !this.org.secrets.webhookSecret && !(this.org.webhooks && this.org.webhooks.length)) {
          await this.getWebhookSecret();
          // double check to make sure org doesn't have token already
          if (!this.webhookToken) {
            await OrgService.regenerateWebhookToken(this.org._id);
          }
        }
        await this.$store.dispatch(actions.WEBHOOK_CREATE, {
          url: this.webhookUrl,
          enabled: true,
        });
        await this.pullFromDB();
        this.webhookUrl = '';
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.$message.error('Failed to create webhook. Please refresh and try again.');
      }
    },
    // for data fields on webhook
    async setWebhookData(id: string, data: any) {
      await this.updateWebhook(id, { ...data, saveState: SAVE_STATE.UNSAVED });
    },
    // push changes to store
    async updateWebhook(id: string, data: any) {
      this.$store.commit(mutations.STORE_WEBHOOK_DATA, { id, data });
    },
    // push changes to store and update DB
    async updateAndPush(id: string, data: any) {
      this.updateWebhook(id, data);
      await this.pushWebhookChanges(id);
    },
    // push what's in store to DB
    async pushWebhookChanges(id: string) {
      try {
        this.$store.commit(mutations.STORE_WEBHOOK_DATA, { id, data: { editable: false } });
        await this.$store.dispatch(actions.WEBHOOK_UPDATE, { id });
      } catch (e) {
        console.log(e);
        this.$message.error('Failed to update webhook. Please refresh and try again.');
      }
    },
    async pullFromDB() {
      this.loading = true;
      await this.$store.dispatch(actions.WEBHOOK_FETCH_ALL);
      this.loading = false;
    },
  },
});
